import React, {useCallback, useEffect, useState} from 'react';
import './App.css';
import Amplify, {Auth, Hub} from "aws-amplify";
import {SignInButtons, SignOutButtons} from "./components/SignInOutButtons";
import UnblockStatus from "./components/UnblockStatus";
import axios from "axios"

const oauth = {
    domain : 'spaceape-shared.auth.us-east-1.amazoncognito.com',
    scope : ['email', 'profile', 'openid'],
    redirectSignIn : process.env.REACT_APP_OAUTH_REDIRECT_URI,
    redirectSignOut : process.env.REACT_APP_OAUTH_REDIRECT_URI,
    responseType: 'code',
};

Amplify.configure({
    Auth: {
        oauth: oauth,
        region: 'us-east-1',
        userPoolId: process.env.REACT_APP_COGNITO_USERPOOL_ID,
        userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
    }
});


const App = () => {
    const DEFAULT_ENV = "prod";
    const LOCALSTORAGE_KEY = "unblockEnvironment";
    const ENV_QUERY_PARAM = "env";

    const [authState, setAuthState] = useState({
        authenticated: false,
        authenticating: true,
    });

    const [unblockState, setUnblockState] = useState({
        success: false,
        failed: false,
        unblocking: false
    });

    const getEnvironmentFromQueryParams = () => new URLSearchParams(window.location.search).get(ENV_QUERY_PARAM);
    const setEnvironmentInLocalStorage = (env) => localStorage.setItem(LOCALSTORAGE_KEY, env);
    const getEnvironmentFromLocalStorage = () => localStorage.getItem(LOCALSTORAGE_KEY);

    // we use useCallback so that the functions here only get defined once (on page load).
    // without this they would get re-defined on each render, and could useEffect to go into a spin
    const getEnvironment = useCallback(() => {
        let env = getEnvironmentFromQueryParams();
        if (env) {
            return env
        }
        env = getEnvironmentFromLocalStorage();
        if (env) {
            return env
        }
        return DEFAULT_ENV
    }, []);

    const unblockIp = useCallback( async (token) => {
        const environment = getEnvironment();
        let proxyUrl = "https://service-proxy-us-east-1.flamingo.apelabs.net";
        if (environment === "prod" || environment === "preprod") {
            proxyUrl = "https://service-proxy-us-east-1.prod.flamingo.apelabs.net"
        }
        const url = `${proxyUrl}/web/${environment}/game-service/443/whitelist/add`;
        const  headers = {
            'Accept': 'application/json',
            'Authorization': token
        };
        await axios.post(url, {}, {headers: headers});
    }, [getEnvironment]);

    const showSignOutButton = (process.env.REACT_APP_SHOW_SIGN_OUT === "true"); //for local dev

    /*
        This function will be called once - when the page loads.
        The page load will either be un-authenticated, or it will be the redirect after Cognito authentication (success
        or failure)
     */
    useEffect(() => {
        Auth.currentAuthenticatedUser()
            .then(u => {
                setAuthState( {authenticated: true, authenticating: false});
                setUnblockState({unblocking: true, success: false, failed: false});
                unblockIp(u.getSignInUserSession().getIdToken().getJwtToken()).then(() => {
                    setUnblockState({unblocking: false, success: true, failed: false})
                }).catch(e => {
                    console.log(e);
                    setUnblockState({unblocking: false, success: false, failed: true})
                });
                localStorage.removeItem(LOCALSTORAGE_KEY)
            })
            .catch(e => {
                console.log(e);
                setAuthState( {authenticated: false, authenticating: false});
            });
    }, [unblockIp]);

    useEffect(() => {
        Hub.listen('auth', ({ payload: { event, data } }) => {
            switch (event) {
                case 'customOAuthState':
                    setEnvironmentInLocalStorage(data);
                    break;
                default:
            }
        })
    },[]);

    return (
        <div className="App">
          <div className="Body">
              <div className="Container">
                  <img src={"beatstar-logo.png"} alt={"Beatstar Logo"} className="LogoLarge"/>
                  {
                      (!authState.authenticated && !authState.authenticating && !unblockState.success) ?
                          <div>
                              <p className="welcomeText">Login to Unblock Your IP</p>
                            <SignInButtons
                                env={getEnvironment()}
                                setLoading={() => setAuthState({...authState, authenticating: true})}/>
                          </div>
                          :
                          <div>
                              <UnblockStatus
                                  environment={getEnvironment()}
                                  authenticating={authState.authenticating}
                                  unblocking={unblockState.unblocking}
                                  success={unblockState.success}
                                  failed={unblockState.failed}
                              />
                          </div>
                  }
                  {showSignOutButton &&<div><SignOutButtons/></div>}
              </div>
          </div>
        </div>
    );
};

export default App;
